




// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloArbo } from '@/models/alo/AloArbo'
import { ItemPanier } from '@/models/alo/ItemPanier'
import CarteRoomService from '@/components/carte/CarteRoomService.vue'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'RoomService',
  props:{
    sectionId:{
      type:Number,
      default:-1
    },
    pageId:{
      type:Number,
      default:-1
    }
  },
  components:{CarteRoomService}
})
export default class RoomService extends Vue {
   
  sectionId!:number
  pageId!:number
  selectedSectionIdx:number = 0
  selectedPageIdx:number = 0
  
  
  private get arbosDic(){
    return this.$store.myGetters.arbosDic
  }

  get panier(){
    return this.$store.myGetters.panier
  }

  canAddFromArbo(arbo:AloArbo){
    return this.panier.canAddFromArbo(arbo);
  }

  addToCart(itemPanier:ItemPanier) {    
    if(this.canOrder)        {    
      if(!itemPanier.arboId || this.panier.canAddFromArbo(this.arbosDic[itemPanier.arboId]) ) {      
        this.$store.myActions.ROOM_SERVICES_ADD_PANIER(itemPanier)
      }     
      else {
        alert("Attention temps incompatible")
      }
    }
    else if(this.isAuthenticated) {
      this.$confirm(this.$t('Cart.InOrderToValidateEnterStay').toString(),{title: this.$t('App.AlertAddCart'),buttonTrueText:this.$t('Login.StayDate'),buttonFalseText:this.$t('Global.Cancel')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$router.push({name:'NewSejour',params:{useUser:'1'}})
        } 
      })            
    }
    else {      
      this.$confirm(this.$t('Cart.InOrderToValidate').toString(),{title: this.$t('App.AlertAddCart'),buttonTrueText:this.$t('Login.LoginAction'),buttonFalseText:this.$t('Login.CreateAccess')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          if(this.$route.name!='Login') this.$router.push({name:'Login'})  
        } 
        else{
          this.$router.push({name:'NewSejour',params:{useUser:'0'}})
        }
      })
    }
  }
  

  get canOrder() {
    return this.$store.myGetters.canOrder
  }

  get isAuthenticated(){
    return this.$store.myGetters.isAuthenticated
  }

  

}
